import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// Store：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class PhotographyStore {
    @observable namespace = 'photography';

    
    constructor(initData = {}) {

    }

}

// 不再导出 Store 实例，全部用 Action 实例